module.exports = __webpack_public_path__ + "img/fo.fd474191.svg";